import { Pipe, PipeTransform } from '@angular/core';
import { resolveAvatarUrl, AVATAR_THUMB_WIDTH } from 'src/app/@services/app-media-url.util';

/**
 * Resolves a media path to a small avatar URL (`?w=` thumbnail).
 * Usage: {{ path | appAvatar }} or {{ path | appAvatar:80 }}
 */
@Pipe({ name: 'appAvatar' })
export class AppAvatarPipe implements PipeTransform {
  transform(pathOrUrl: unknown, width: number = AVATAR_THUMB_WIDTH): string | null {
    return resolveAvatarUrl(pathOrUrl == null ? null : String(pathOrUrl), width);
  }
}
